// @flow
import React from 'react'
import formatters from 'lib/formatters'
import Row from './Row'
import styles from './styles.css'

type Props = {
  account: ?Object,
  status: ?string,
  statement_info: ?string,
  created_at: ?string,
  updated_at: ?string,
  close_date: ?string,
  subaccount_type: ?string,
  open_date: ?string,
}

const AccountInfoSection = (props: Props) => {
  const {
    account,
    status,
    statement_info = '-',
    created_at = null,
    updated_at = null,
    close_date = null,
    subaccount_type = null,
    open_date = null,
  } = props

  if (!account) return null

  const { close_date: account_close_date = null, floor = null } = account || {}

  const accountStatus = status === null ? 'pending' : status || (close_date || account_close_date ? 'Closed' : 'Active')

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return styles.dateStyleActive
      case 'closed':
        return styles.dateStyleClosed
      case 'pending':
        return styles.dateStylePending
      default:
        return styles.dateStyleActive
    }
  }

  const getDateInfoClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return styles.dateInfoOpen
      case 'closed':
        return styles.dateInfoClosed
      case 'pending':
        return styles.dateInfoPending
      default:
        return styles.dateInfoOpen
    }
  }

  return (
    <div className={getStatusClass(accountStatus)}>
      <div className={styles.flexRow}>
        <div className={styles.accountInfo}>
          <div className={styles.titleWithIcon}>
            <h5>Account Information</h5>
            <div className={styles.refEditSmall}></div>
          </div>
          <div className={styles.lastUpdated}>
            <Row label="Last Update:" val={updated_at ? formatters.lastUpdate(updated_at) : '-'} />
          </div>
        </div>
        <span className={styles.statusText}>{formatters.legibleAccountStatus(accountStatus)}</span>
      </div>
      <div className={getDateInfoClass(accountStatus)}>
        <Row
          label="Open Date"
          val={subaccount_type === 'msa' ? (open_date ? formatters.date(open_date) : '-') : created_at ? formatters.date(created_at) : '-'}
        />
        <Row label="Close Date" val={close_date || account_close_date ? formatters.date(close_date || account_close_date) : '-'} />
      </div>
      <div className={styles.singleLine}>
        <div className={styles.label}>Floor</div>
        <div className={styles.value}>{floor ? formatters.money(floor) : '-'}</div>
      </div>

      <div className={styles.separator}></div>

      <div className={styles.singleLine}>
        <div className={styles.label}>Statement Info</div>
        <div className={styles.value}>{statement_info || '-'}</div>
      </div>
    </div>
  )
}

export default AccountInfoSection
